import { getInsights } from '@/services/dashboard-service/dashboard.service';
import { DashboardFilters } from '@/services/dashboard-service/dashboard.service.types';
import { ReactQueryKeys } from '@/utils/react-query-keys';
import { useQuery } from '@tanstack/react-query';

export function useInsights(params: DashboardFilters, isCompanyAdmin?: boolean) {
  const enabled = isCompanyAdmin || !!params.company_name;

  const {
    data: insightsData,
    error,
    isPending,
    isLoading,
  } = useQuery({
    queryKey: ReactQueryKeys.INSIGHTS(params),
    queryFn: () => getInsights(params),
    enabled,
  });

  // `isPending` stays true forever on a disabled query, so a caller distinguishing
  // "still arriving" from "will never arrive" needs `isLoading`.
  return { insightsData, error, isPending, isLoading };
}
